<div class="content dark">
	<div class="row">
		<div class="col-md-12">
			<p>Lists all emails sent via the Foresight system. Note that bounced emails should be prevented
				(investigated with the customer in question) because too many bounces will cause a low reputation score
				and cause the sending account to be suspended. Complained status is even worse, indicating that a customer
				reported the email as spam.</p>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12 form-group">
			<label class="form-check-label">
				<input type="checkbox" [(ngModel)]="noDelivered" (ngModelChange)="refreshTable()">
				Exclude successful deliveries
			</label>
		</div>
	</div>
	<div class="row mb-3">
		<div *ngIf="filters.asset?.name" class="col-sm-6 col-md-6">
			Asset: {{filters.asset?.name}}
			<i (click)="removeFilter('asset')" class="icon-minus-circled clickable"></i>
		</div>
		<div *ngIf="!filters.asset" class="col-sm-8 form-inline">
			<label>Filter to asset:</label>
			<select [(ngModel)]="selectedAsset" (ngModelChange)="FilterAsset($event)" class="form-control ml-2">
				<option *ngFor="let asset of assetList" [ngValue]="asset">{{asset.fleet_name}} / {{asset.asset_name}} ({{asset.obcu_serial_number}})</option>
			</select>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<table class="table-sent-emails">
				<thead>
					<tr>
						<th>Timestamp</th>
						<th>Recipient</th>
						<th>Subject</th>
						<th>Status</th>
						<th>Asset</th>
					</tr>
				</thead>
				<tbody *ngFor="let email of pageEmails">
					<tr>
						<td>
							<span title="{{email.timestamp}}">
								<span>{{email.timestamp | datetime : "localshort"}}</span>
							</span>
						</td>
						<td>{{email.recipient}}</td>
						<td>{{email.subject}}</td>
						<td [style.color]="email.status | sentemailstatuscolor">{{email.status}}</td>
						<td><a *ngIf="email.asset_id" [href]="'/dash/fleet/' + email.fleet_id + '/asset/' + email.asset_id">{{email.asset_name}} <i class="icon-link-ext"></i></a></td>
					</tr>
				</tbody>
			</table>
			<ngb-pagination [collectionSize]="totalEmails" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
				[rotate]="true"></ngb-pagination>
		</div>
	</div>
</div>